import { Skeleton } from "@/components/ui/skeleton";

interface ChartSkeletonProps {
  className?: string;
}

/** Placeholder occupying the same footprint as a chart while its data loads. */
export function ChartSkeleton({ className = "h-[200px]" }: ChartSkeletonProps) {
  return (
    <div className={`flex w-full items-end gap-3 ${className}`}>
      {[70, 45, 85, 55, 90, 40, 65].map((height, i) => (
        <Skeleton key={i} className="w-full" style={{ height: `${height}%` }} />
      ))}
    </div>
  );
}

export function LegendSkeleton({ rows = 3 }: { rows?: number }) {
  return (
    <div className="flex w-full flex-col gap-2">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Skeleton className="size-2 shrink-0" />
            <Skeleton className="h-3 w-20" />
          </div>
          <Skeleton className="h-3 w-6" />
        </div>
      ))}
    </div>
  );
}
